function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import * as Dialog from '../../../_snowpack/pkg/@crystallize/react-dialog.js';
import { Button, colors, DialogButton, Icon } from '../../css/index.js';
import WarningImage from '../../icons/svg/warning.svg';
const H1 = styled.h1.withConfig({
  displayName: "wrapper__H1",
  componentId: "sc-108f2zx-0"
})(["font-weight:300;font-size:30px;color:", ";"], colors.frostbite);
export const ButtonClose = styled(Button).attrs(() => ({
  small: true
})).withConfig({
  displayName: "wrapper__ButtonClose",
  componentId: "sc-108f2zx-1"
})(["position:absolute;top:-16px;left:-18px;"]);
export const Container = styled.div.withConfig({
  displayName: "wrapper__Container",
  componentId: "sc-108f2zx-2"
})(["dialog{border-radius:12px;box-shadow:0 0 30px 0 rgba(0,0,0,0.05);width:fit-content;}.crystallize-dialog{position:relative;&--confirm{padding-left:150px;border-radius:15px;}", "{font-size:20px;}&--confirm:before{width:150px;height:100%;left:0;top:0;content:'';position:absolute;background:", ";}&:after{width:150px;height:100%;left:0;top:0;position:absolute;}&-inner{padding:40px 30px 20px 30px;color:", ";}&-close-button-positioner{right:0;top:0;}&--confirm:after,&--alert:after{content:'';background-image:url(", ");background-size:120px;opacity:0.7;background-repeat:no-repeat;background-position:center;}}.crystallize-dialog-buttons{padding-top:20px;}.crystallize-dialog-inner{width:fit-content;border-radius:12px;padding:70px 60px;}"], H1, colors.lightGrey, colors.frostbite, WarningImage);
export const CloseButtonWrapper = styled.button.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "wrapper__CloseButtonWrapper",
  componentId: "sc-108f2zx-3"
})(["border:0;outline:0;height:60px;width:50px;cursor:pointer;background:transparent;&:hover{background:rgba(0,0,0,0.03);}"]);

const DialogWrapper = () => {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Dialog.Wrapper, {
    cleanTheme: true,
    ButtonOk: DialogButton,
    ButtonCancel: p => /*#__PURE__*/React.createElement(DialogButton, _extends({
      secondary: true
    }, p)),
    Heading: H1,
    ButtonClose: props => /*#__PURE__*/React.createElement(CloseButtonWrapper, _extends({}, props, {
      "data-cypress": "dialog_close_button"
    }), /*#__PURE__*/React.createElement(Icon.Cancel, {
      color: 'density',
      width: 15,
      height: 15
    }))
  }));
};

DialogWrapper.propTypes = {};
DialogWrapper.defaultProps = {};
export default DialogWrapper;